import { Config } from "../config";
import { store } from "./store";
import { logout } from "../pages/login/loginSlice";

export interface ApiFetchOptions extends Omit<RequestInit, "headers"> {
    token?: string | null;
    headers?: Record<string, string>;
}

// Centralizes the API base URL and Authorization/Content-Type headers that
// were previously duplicated across FolderContents, PreviewPane and
// ComposeMailItem. Callers still own their own useEffect/AbortController/
// loading state - this only removes the copy-pasted URL/header construction.
//
// Also centralizes session-expiry handling: a 401/403 means the JWT is
// dead, so we clear the persisted session (which also triggers Inbox's
// reactive redirect to /login) and throw a SessionExpiredError so callers
// can skip showing a misleading "failed to load" message, the same way
// they already skip it for AbortError.
export async function apiFetch(path: string, options: ApiFetchOptions = {}): Promise<Response> {
    const { token, headers, ...rest } = options;
    const response = await fetch(Config.apiEndpoint + path, {
        mode: "cors",
        ...rest,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { "Authorization": "Bearer " + token } : {}),
            ...headers
        }
    });

    if (response.status === 401 || response.status === 403) {
        store.dispatch(logout());
        const sessionError = new Error("Session expired");
        sessionError.name = "SessionExpiredError";
        throw sessionError;
    }

    return response;
}
